import safeLocalStorage from 'pricing-pages-ui-components/utils/safeLocalStorage';
import safeSessionStorage from 'pricing-pages-ui-components/utils/safeSessionStorage';
import { BROWSER_LOCALE_KEY, COUNTRY_CODE_KEY, FF_OVERRIDES_KEY, I18N_LANG_KEY, getFeatureFlagOverrides } from 'pricing-pages-ui-components/utils/debugOverrides';
export { FF_OVERRIDES_KEY, COUNTRY_CODE_KEY, BROWSER_LOCALE_KEY, I18N_LANG_KEY, getFeatureFlagOverrides, applyFeatureFlagOverrides, getCountryCodeOverride, getBrowserLocaleOverride, getI18nLangOverride, getActiveOverrideCount } from 'pricing-pages-ui-components/utils/debugOverrides';
export function setFeatureFlagOverride(flag, value) {
  const current = getFeatureFlagOverrides();
  if (value === null) {
    delete current[flag];
  } else {
    current[flag] = value;
  }
  if (Object.keys(current).length === 0) {
    safeLocalStorage.removeItem(FF_OVERRIDES_KEY);
  } else {
    safeLocalStorage.setItem(FF_OVERRIDES_KEY, JSON.stringify(current));
  }
}
export function setCountryCodeOverride(code) {
  if (code) {
    safeSessionStorage.setItem(COUNTRY_CODE_KEY, code.toUpperCase());
  } else {
    safeSessionStorage.removeItem(COUNTRY_CODE_KEY);
  }
}
export function setBrowserLocaleOverride(locale) {
  if (locale) {
    safeSessionStorage.setItem(BROWSER_LOCALE_KEY, locale);
  } else {
    safeSessionStorage.removeItem(BROWSER_LOCALE_KEY);
  }
}
export function setI18nLangOverride(lang) {
  if (lang) {
    safeLocalStorage.setItem(I18N_LANG_KEY, lang);
  } else {
    safeLocalStorage.removeItem(I18N_LANG_KEY);
  }
}
export function clearAllOverrides() {
  safeLocalStorage.removeItem(FF_OVERRIDES_KEY);
  safeSessionStorage.removeItem(COUNTRY_CODE_KEY);
  safeSessionStorage.removeItem(BROWSER_LOCALE_KEY);
  safeLocalStorage.removeItem(I18N_LANG_KEY);
}